export const phoneNumberValidator = (value: string): string | null => {
  const re = /^[+]?[(]?[\d]{3}[)]?[-\s.]?[\d]{3}[-\s.]?[\d]{4,6}$/im;

  if (value && !re.test(value)) {
    return 'Phone Number Invalid';
  } else {
    return null;
  }
};
